import convertRetainToPoint from '../utils/convertRetainToPoint';
export default function deleteOperation(editor, op) {
  var _convertRetainToPoint = convertRetainToPoint(editor, op["delete"]),
      path = _convertRetainToPoint.path,
      offset = _convertRetainToPoint.offset,
      isLast = _convertRetainToPoint.isLast;

  if (isLast) {
    editor.moveEndTo(editor.value.document.getLastText().key).moveEndToEndOfText();

    if (editor.value.blocks.size >= 1) {
      editor.value.blocks.forEach(function (block) {
        editor.removeNodeByKey(block.key);
      });
    } else {
      editor["delete"]();
    }

    return editor;
  }

  editor.moveEndTo(path, offset); // If end is at beginning of a void inline (like mention), we need to go back
  // to the end of previous text. This is the same selection, except the next
  // delete operation won't delete the whole next inline.

  if (editor.value.endInline && editor.isVoid(editor.value.endInline) && offset === 0) {
    editor.moveEndToEndOfPreviousText();
  } // If selection is over two blocks, delete() will merge them and keep first
  // block properties. In ot/rich-text, a delete operation work the other way.
  // So we delete everything and keep next block attributes.


  var endBlock = editor.value.endBlock;
  return editor["delete"]().setBlocks({
    type: endBlock.type,
    data: endBlock.data
  });
}